import React from 'react';
import { Truck } from '@phosphor-icons/react';
import { useGmTransport } from '../lib/gmTransport';

export const GmTransportToggle = ({ testid = 'gm-transport-toggle', className = '' }) => {
  const { withTransport, setWithTransport } = useGmTransport();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={withTransport}
      onClick={() => setWithTransport(!withTransport)}
      title="GM with transport counts the transport charge as revenue and as freight cost"
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-medium transition-colors ${
        withTransport ? 'bg-[#E2F3F0] border-[#00a69c] text-[#00857e]' : 'bg-white border-[#D5E8E4] text-[#3B5A54] hover:bg-[#F4F9F7]'} ${className}`}
      data-testid={testid}
    >
      <Truck size={14} weight={withTransport ? 'fill' : 'regular'} />
      GM {withTransport ? 'with' : 'without'} transport
      <span className={`relative w-7 h-4 rounded-full transition-colors ${withTransport ? 'bg-[#00a69c]' : 'bg-[#CBD5D1]'}`}>
        <span className={`absolute top-0.5 w-3 h-3 rounded-full bg-white transition-transform ${withTransport ? 'translate-x-3.5' : 'translate-x-0.5'}`} />
      </span>
    </button>
  );
};

export default GmTransportToggle;
